import { render } from "./public-facility-card.vue?vue&type=template&id=7e95c65a&scoped=true"
import script from "./public-facility-card.vue?vue&type=script&lang=js"
export * from "./public-facility-card.vue?vue&type=script&lang=js"

import "./public-facility-card.vue?vue&type=style&index=0&id=7e95c65a&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e95c65a"]])

export default __exports__